<template>
  <div>
    <overwatchLoader id='loader' v-if='!site'/>
    <div id='mercureRatesHorizontalV2' class='d-flex flex-column justify-content-around' v-if='site'>
      <div id='master' class='d-flex flex-column justify-content-center align-items-center'>
        <div class="titleBloc d-flex flex-row justify-content-start align-items-center">
          <div class="title">{{ $tlang(lg1, 'novotel.rates.roomRatesTitle') }}*</div>
          <div class="subtitle">{{ $tlang(lg2, 'novotel.rates.roomRatesTitle') }}*</div>
        </div>
        <div id='main' class='d-flex flex-row justify-content-between'>
          <rates class='left' :ratesLg='ratesServicesLeft'></rates>
          <rates class='right' :ratesLg='ratesServicesRight'></rates>
        </div>
        <div id="additionalServices" v-if="additionalServices" class="d-flex justify-content-start align-items-center">
          <div class="lg1" v-html="additionalServices.lg1.label_value"></div>
          <div class="lg2" v-html="additionalServices.lg2.label_value"></div>
        </div>
        <div id="legalNotice">
          <div v-for="(notice, index) in legalNoticeLgLeft.lg1" :key="notice">
            <span class="lg1" v-if="notice.ta_value" v-html="notice.ta_value"></span> 
            <span class="lg2" v-if="legalNoticeLgLeft.lg2[index]" v-html="legalNoticeLgLeft.lg2[index].ta_value"></span> 
          </div>
          <div v-for="(notice, index) in legalNoticeLgCenter.lg1" :key="notice">
            <span class="lg1" v-if="notice.ta_value" v-html="notice.ta_value"></span> 
            <span class="lg2" v-if="legalNoticeLgLeft.lg2[index]" v-html="legalNoticeLgLeft.lg2[index].ta_value"></span> 
          </div>
        </div>
        <svg id="logo_m" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 394"><defs></defs><path d="M120.62,134.09h1.09c11.17-.13,32.83,2.06,52.33,18.12,18.06,14.88,29,37.19,32.39,66.34l42.42-79.29a2.12,2.12,0,0,1,2.8-.85l9.38,5.25a2,2,0,0,1,1.1,1.82l5.65,51.5,41.63-58.55a2.17,2.17,0,0,1,2.74-.65l.17.12,6.34,5.4a1.86,1.86,0,0,1,1,1.75c-1.81,20.77,3.77,44,14.91,62.05,9.78,15.88,29,36.53,63.41,40.32l.54.06.9,2.18h-1.32c-24.35.27-45.94-6.8-62.46-20.43-18.75-15.49-30-38.33-33.37-67.9l-38.14,54.35a1.89,1.89,0,0,1-2.82.3c-.15-.08-.3-.17-.47-.25l-8.22-4.26a1.86,1.86,0,0,1-1.1-1.79l-5.16-47.25-45,82.85c-1,1.64-2.36.86-3.1.45l-.46-.25-7.61-3.91a3.14,3.14,0,0,1-1.7-3c3.74-55.93-23.22-97.6-66.79-102.49l-.61-.07Z" transform="translate(0 0)"/><rect class="cls-1" width="520" height="394"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import Titles from './titles'
import Rates from './rates/rates'
import OverwatchLoader from '../../../../loader/overwatch'
import model from '../../../../debug/model'

export default {
  name: 'mercureRatesHorizontalV2',
  components: {
    pageTitles: Titles,
    rates: Rates,
    OverwatchLoader,
    model,
  },
  data: function () {
    return {
      rightOrder: ['change', 'hosts', 'messages'],
      model: [],
      rightIndex: -1,
      msgCurrentPage: 1,
      goNextComponent: true
    }
  },
  mounted () {
    this.$dm.getData(this.$route) // get data on start
    // this.alternates()
  },
  computed: {
    ratesLg () {
      let rates = this.site && this.site.get('rates')
      if (rates) {
        let data = rates.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id],
            lg2: data[data.languages[1].id]
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    /*
    filteredServices: function () { // remove additional services if necessary
      if (this.ratesLg.lg1.settings.additional_services === '1') {
        return { lg1: this.ratesLg.lg1.otherServices.regular.slice(0, -1), lg2: this.ratesLg.lg2.otherServices.regular.slice(0, -1) }
      } else {
        return { lg1: this.ratesLg.lg1.otherServices.regular, lg2: this.ratesLg.lg2.otherServices.regular }
      }
    },
    */
    ratesLG1 () {
      return this.ratesLg.lg1.rates2;
    },
    ratesLG1Length () {
      return Object.keys(this.ratesLG1).length;
    },
    servicesLeftLG1 () {
      return  this.ratesLg.lg1.otherServices.regular;
    },
    servicesLeftLG1Length () {
      const len = Object.keys(this.servicesLeftLG1).length;
      if (this.ratesLg.lg1.settings.additional_services === '1') {
        return len - 1;
      } else {
        return len;
      }
    },
    servicesRightLG1 () {
      return  this.ratesLg.lg1.otherServices.right;
    },
    servicesRightLG1Length () {
      return Object.keys(this.servicesRightLG1).length;
    },
    ratesServices () {
      let ratesServices = [];
      const count = Math.min(10, this.ratesLG1Length + this.servicesLeftLG1Length + this.servicesRightLG1Length);
      for (let i = 0; i < this.ratesLG1Length; i++) {
        if (ratesServices.length < count) {
          ratesServices.push({ type: "rate", lg1:  this.ratesLG1[i + 1], lg2: this.ratesLg.lg2.rates2[i + 1] })
        }
      }
      for (let i = 0; i < this.servicesLeftLG1Length; i++) {
        if (ratesServices.length < count) {
          ratesServices.push({ type: "service", lg1:  this.servicesLeftLG1[i], lg2: this.ratesLg.lg2.otherServices.regular[i] })
        }
      }
      for (let i = 0; i < this.servicesRightLG1Length; i++) {
        if (ratesServices.length < count) {
          ratesServices.push({ type: "service", lg1:  this.servicesRightLG1[i], lg2: this.ratesLg.lg2.otherServices.right[i] })
        }
      }
      return ratesServices;
    },
    ratesServicesLeft () {
        return this.ratesServices.slice(0, Math.ceil(this.ratesServices.length / 2));
    },
    ratesServicesRight () {
        return this.ratesServices.slice(-Math.floor(this.ratesServices.length / 2));
    },
    changeLg () {
      let change = this.site && this.site.get('change')
      if (change) {
        let data = change.get('data')
        if (data) {
          return {
            lg1: data[data.languages[0].id].exchangeRate,
            lg2: data[data.languages[1].id].exchangeRate
          }
        } else {
          return null
        }
      } else {
        return null
      }
    },
    messages () {
      try {
        return this.site && this.site.get('messages').get('data')
      } catch (error) {
        return null
      }
    },
    netStatus () {
      return this.$store.state.connected
    },
    site () {
      let site = this.$store.getters.site
      console.log('site()', site)
      return site
    },
    user () {
      return this.$store.getters.user
    },
    device () {
      return this.$store.getters.device
    },
    rightStatus () {
      return this.rightOrder[this.rightIndex]
    },
    siteName () {
      try {
        return this.site.get('rates').get('data').siteName
      } catch (e) {
        return ''
      }
    },
    page () {
      return this.$route.query.page
    },
    transitionName () {
      if (this.page) {
        return 'off' // no transition if page is forced
      } else {
        return 'fade'
      }
    },
    additionalServices: function () {
      if (this.ratesLg.lg1.settings.additional_services === '1') {
        let regularLg1 = this.ratesLg.lg1.otherServices.regular
        let regularLg2 = this.ratesLg.lg2.otherServices.regular
        return { lg1: regularLg1[regularLg1.length - 1], lg2: regularLg2[regularLg2.length - 1] }
      } else {
        return null
      }
    },
    lg1 () {
      return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
    },
    lg2 () {
      return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
    },
    legalNoticeLgLeft () {
      return {lg1: this.ratesLg.lg1.subtitles['1'], lg2: this.ratesLg.lg2.subtitles['1']}
    },
    legalNoticeLgCenter () {
      if (this.ratesLg) {
        return {lg1: this.ratesLg.lg1.subtitles['2'], lg2: this.ratesLg.lg2.subtitles['2']}
      } else {
        return null
      }
    },
  },
  watch: {
    netStatus (newStatus, oldStatus) {
      console.log('netStatus update', oldStatus, newStatus)
      // Get data on connection status change
      if (oldStatus) { // getData must not be done the first time
        console.log('netStatus getdata')
        this.$dm.getData(this.$route)
      }
    },
    user (newUser, oldUser) {
      console.log('User update', oldUser, newUser)
      // Get data when user is logged
      if (oldUser && newUser) {
        console.log('user getdata')
        this.$dm.getData(this.$route)
      }
    },
    device (newDevice, oldDevice) {
      console.log('Device update', oldDevice, newDevice)
      // refresh data on device update
      if (oldDevice && oldDevice._objCount && newDevice) {
        console.log('device getdata')
        this.$dm.getData(this.$route)
      }
    },
    site (newSite, oldSite) {
      console.log('Site updated', oldSite, newSite)
    }
  },
  methods: {
    alternates () {
      if (this.page) { // for test purpose
        this.rightIndex = this.page
      } else {
        let display =
          (this.changeLg && this.changeLg.lg1.rates.length) ||
          (this.ratesLg && this.ratesLg.lg1.inCharge.length) ||
          (this.messages && this.messages.clients_messages.length)
        if (!display) {
          setTimeout(this.alternates, 1000)
          return
        }
        if (this.goNextComponent) {
          this.rightIndex++
        }
        if (this.rightIndex >= this.rightOrder.length) {
          this.rightIndex = 0
        }
      }
      let len = 0
      switch (this.rightStatus) {
        case 'change':
          this.goNextComponent = true
          len = this.changeLg && this.changeLg.lg1.rates.length
          if (!len) {
            this.alternates()
            return
          }
          break
        case 'hosts':
          this.goNextComponent = true
          if (this.ratesLg) {
            len = this.ratesLg && this.ratesLg.lg1.inCharge.length
          }
          if (!len) {
            this.alternates()
            return
          }
          break
        case 'messages':
          this.goNextComponent = true
          len = this.messages && this.messages.clients_messages.length
          if (!len) {
            this.alternates()
            return
          }
          if (this.$refs.messages.nextPage()) {
            this.goNextComponent = false
          }
          break
      }
      setTimeout(this.alternates, 7000)
    }
  }
}
</script>

<style lang='scss' scoped>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_mercure2021.scss";

#mercureRatesHorizontalV2 {
  width: 160vh; // https://www.alsacreations.com/article/lire/1490-comprendre-le-viewport-dans-le-web-mobile.html
  height: 100vh;
  background-color: white;
  
  #master {
    // position: absolute;
    // width: 160vh;
    // height: 100vh;

    .titleBloc {
        font-family: "Montserrat-Regular";
        @include widthPercent(1804);
        text-transform: uppercase;

        .title {
            @include fontSize(57);
            color: $grey;
        }

        .subtitle {
            @include fontSize(57);
            color: $purple;
            margin-left: 20px;
        }
    }


    #main {
      @include widthPercent(1804);

      .left {
        @include widthPercent(940);
        padding-top: 40px;
      }

      .right {
        @include widthPercent(814);
        padding-top: 40px;
      }
    }

    #additionalServices {
      font-family: "Montserrat-Regular";
      @include widthPercent(1804);
      @include heightPercent(106);
      border-top : 1px solid $grey;
      border-bottom : 1px solid $grey;
    }


    #legalNotice {
      font-family: "Montserrat-Regular";
      @include widthPercent(1804);
      padding-right: 160px;
      padding-top: 10px;
      div {
        display: inline;

        & + div {
          padding-left: 10px;
        }
      }
    }

    #logo_m {
       @include widthPercent(260);
       @include heightPercent(197);
       position : absolute;
       right: 0px;
       bottom: 25px;
       .cls-1{fill:none;opacity:0.4;}
    }
  }
}

</style>

<style lang='scss'>
$srcWidth : 1920;
$srcHeight : 1200;
@import "../../../_mercure2021.scss";
@import "../../../../../../scss/global.scss";

#app {
  @extend .gradientBackground;
}

.lg1 {
  color: $grey;
}

.lg2 {
  color: $lightGrey;
}

#mercureRatesHorizontalV2 {
  .additional_services {

    p {
      display: inline-block;
      margin: 0;

      &::first-letter {
        text-transform: uppercase;
      }
      margin-right: 10px;

      &:nth-of-type(1) {
        @include fontSize(36);
      }

       &:nth-of-type(2) {
        @include fontSize(30);
        &::before {
          content: " - ";
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v2/mercureRatesHorizontalV2.vue